import { useEffect } from "react";

const SEL = "main h1, main h2, main h3, main p, main img, main form, main .grid > *, main section > div > *, main [data-reveal], footer .grid > *, footer p, footer span";

export const ScrollReveal = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const io = new IntersectionObserver((entries) => {
      entries.filter((e) => e.isIntersecting).forEach((e, i) => {
        e.target.style.animationDelay = `${Math.min(i * 70, 420)}ms`;
        e.target.classList.add("reveal-in");
        io.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: "0px" });
    const scan = () => document.querySelectorAll(SEL).forEach((el) => {
      if (el.dataset.rv || el.closest("[data-no-reveal]") || el.parentElement.closest(".reveal:not(.reveal-in)") || getComputedStyle(el).animationName !== "none" || ["absolute", "fixed", "sticky"].includes(getComputedStyle(el).position)) return;
      el.dataset.rv = "1";
      el.classList.add("reveal");
      io.observe(el);
    });
    scan();
    let t;
    const mo = new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 60); });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      io.disconnect(); mo.disconnect(); clearTimeout(t);
      document.querySelectorAll(".reveal:not(.reveal-in)").forEach((el) => { el.classList.remove("reveal"); delete el.dataset.rv; });
    };
  }, []);
  return null;
};
